import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import LinkedInAccountFormField from "../LinkedInAccountFormField";
import GroupFormField from "./GroupFormField";
import SelectedGroup from "./SelectedGroup";

import type {
  LinkedInGroup as Group,
  GroupLeadListSource,
} from "../../../../types";

import GroupImage from "assets/images/sources/group.png";

interface LinkedInGroupProps {
  accountId: string;
  setAccountId: (accountId: string) => void;
  createSource: (settings: GroupLeadListSource["settings"]) => void;
  isCreatingSource: boolean;
  goBack: () => void;
}

export default function LinkedInGroup({
  accountId,
  setAccountId,
  createSource,
  isCreatingSource,
  goBack,
}: LinkedInGroupProps) {
  const isDesktop = useTwBreakpoint("lg");

  const [selectedGroup, setSelectedGroup] = useState<Group>();

  function addLeads() {
    createSource({ type: "group", group_id: selectedGroup.id });
  }

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Group members"
        onBack={selectedGroup ? () => setSelectedGroup(undefined) : goBack}
      />
      <Body className="gap-y-3 lg:gap-y-6">
        {selectedGroup ? (
          <SelectedGroup group={selectedGroup} />
        ) : (
          <>
            <div className="flex gap-3 lg:gap-5 max-lg:order-3 flex-col lg:flex-row-reverse">
              <LinkedInAccountFormField
                accountId={accountId}
                setAccountId={setAccountId}
              />
              <GroupFormField
                accountId={accountId}
                onSelect={setSelectedGroup}
              />
            </div>
            <img src={GroupImage} alt="" height={238} />
          </>
        )}
      </Body>

      {selectedGroup && (
        <Footer className="justify-between">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>
          <Button
            onClick={addLeads}
            disabled={!selectedGroup}
            isLoading={isCreatingSource}
          >
            Add leads
          </Button>
        </Footer>
      )}
    </>
  );
}
